export enum StudyStatusEnum {
  draft = 'DRAFT',
  startUp = 'START_UP',
  maintenance = 'MAINTENANCE',
  closeUp = 'CLOSE_UP',
  completed = 'COMPLETED',
  onHold = 'ON_HOLD',
  cancelled = 'CANCELLED',
}

export enum UserStatusEnum {
  active = 'ACTIVE',
  deactivated = 'DEACTIVATED',
  inactive = 'INACTIVE',
  invited = 'INVITED',
}

export enum QcStatusEnum {
  'PENDING' = 'PENDING',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'ON_HOLD' = 'ON_HOLD',
  'QUERY_OPEN' = 'QUERY_OPEN',
  'DONE' = 'DONE',
  'FAILED' = 'FAILED',
}

export enum ScoringFormEnum {
  'COMPLETED' = 'COMPLETED',
  'CREATED' = 'CREATED',
  'READING_PENDING' = 'READING_PENDING',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'TERMINATED' = 'TERMINATED',
  'FAILED' = 'FAILED',
}

export enum PatientUploadStatusEnum {
  'CREATED' = 'CREATED',
  'ONGOING' = 'ONGOING',
  'WITHDRAWN' = 'WITHDRAWN',
  'COMPLETED' = 'COMPLETED',
}

export enum VisitStatusEnum {
  'CREATED' = 'CREATED',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'CLOSED' = 'CLOSED',
}

export enum InvitationStatusEnum {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
}

export const QcCompletedStatuses = [QcStatusEnum.DONE, QcStatusEnum.FAILED];

export const PatientCompletedStatuses = [
  PatientUploadStatusEnum.WITHDRAWN,
  PatientUploadStatusEnum.COMPLETED,
];

export const AuditTrailStatuses = [
  ScoringFormEnum.COMPLETED,
  ScoringFormEnum.CREATED,
  ScoringFormEnum.FAILED,
  ScoringFormEnum.READING_PENDING,
  ScoringFormEnum.IN_PROGRESS,
  ScoringFormEnum.TERMINATED,
];
